export class Notifications {
  entityMessage() {
    return `La notification ${this.id}`;
  }

  #motifMaxSize;

  constructor({
    id = null,
    code = null,
    type = null,
    declencheur = null,
    equipe = null,
    contenu = null,
    procedure = null,
    validateur = null,
    statut = null,
    createdDate = null
  } = {}) {
    this.#motifMaxSize = 55;
    this.id = id;
    this.code = code;
    this.type = type;
    this.declencheur = declencheur;
    this.equipe = equipe;
    this.contenu = contenu;
    this.contenuLight = this.formatContenuLight(contenu);
    this.procedure = procedure;
    this.validateur = validateur;
    this.statut = statut;
    this.createdDate = createdDate;
  }

  formatContenuLight(contenu) {
    let result = contenu;
    //result =  contenu.length <=this.#motifMaxSize ? contenu :  contenu.substring(0,this.#motifMaxSize).concat('...').concat('('+contenu.length+')');
    if (result.includes("<html>"))
      result = "Cliquer sur la flèche pour voir le motif de la notification";
    else if (contenu.length > this.#motifMaxSize)
      result = contenu.substring(0, this.#motifMaxSize).concat("...");
    return result;
  }
}
